import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { AbstractControl, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { BaseComponent } from 'src/app/moov-common/base/base.component';
import { SendFeedbackComponent } from 'src/app/moov-common/components/send-feedback/send-feedback/send-feedback.component';
import { IssueData } from 'src/app/moov-common/services/challenge/challenges-data';
import { AbstractChallengesService } from 'src/app/moov-common/services/challenge/challenges.abstract.service';
import { PersonalUserData } from 'src/app/moov-common/services/personal-user-data/personal-user-data';

@Component({
  selector: 'app-select-issue',
  templateUrl: './select-issue.component.html',
  styleUrls: ['./select-issue.component.scss']
})

export class SelectIssueComponent extends BaseComponent implements OnInit  {
  issues: IssueData[];
  selectedIssue: string;
  selectIssueForm: UntypedFormGroup;
  selectedIssueId: UntypedFormControl;
  @Input() counterpartDetails: PersonalUserData;
  @Output() issueSelectedEvent = new EventEmitter<string>();


  constructor(public challengesService: AbstractChallengesService, public dialog: MatDialog) { 
    super();
    super.ngOnInit();
  }

  ngOnInit(): void {
    if (!this.counterpartDetails){
      return;
    }

    this.challengesService.getallIssues(this.counterpartDetails.id).subscribe(issues => {
      this.issues = issues.sort((issue1, issue2) => {
        if (issue1.id > issue2.id){
          return 1;
        }
        else if (issue1.id < issue2.id){
          return -1;
        }
        else{
          return 0;
        }
      });
    });
  }

  initFormGroup() {
    let formControls: { [key: string]: AbstractControl } = {};
    for (let issue of this.issues) {
      formControls[issue.id] = new UntypedFormControl(issue.name); 
    }
    this.selectIssueForm = new UntypedFormGroup(formControls);
  }

  issueSelected(issue: any) {
    this.issueSelectedEvent.emit(issue.id);
  }

  sendFeedback(): void{
    this.dialog.open(SendFeedbackComponent, {
     height: 'fit-content',
     width: (this.isMobileView? '90%':'40%'),
      data: {}
    });
  }

}
